import { useContext } from "react";

import { OrganizationContext } from "./index";

export function useOrganizationContext() {
  return useContext(OrganizationContext);
}
